module.exports = __webpack_public_path__ + "img/support_e1.bd5a1ecf.png";